export default __webpack_public_path__ + "static/media/biz_booking_icon_product_placement.794e798d.svg";